import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=039f8faf&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f8faf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('039f8faf')) {
      api.createRecord('039f8faf', component.options)
    } else {
      api.reload('039f8faf', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=039f8faf&scoped=true&", function () {
      api.rerender('039f8faf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TbXgt1rPox2o/JS/comp/SearchFilterTokens.vue"
export default component.exports